import styled from "styled-components";
import { TabList, TabContext, TabPanel } from "@mui/lab";
import { Tab as MuiTab } from "@mui/material";
import { useEffect, useState } from "react";
import { Children } from "react";
import { useMobile } from "../../utils/mobile";

const StyleTabs = styled(TabList)(({ theme, isMobile }) => ({
  [`&& .MuiButtonBase-root`]: {
    fontSize: isMobile ? 16 : 16,
    fontWeight: isMobile ? 500 : 500,
    color: "#B1B1B1",
    padding: isMobile && 0
  },
  [`&& .MuiTabs-indicator`]: {
    color: `${theme.color.mainBlue} !important`,
    backgroundColor: `${theme.color.mainBlue} !important`,
    height: 4,
  },
  [`&& .Mui-selected`]: {
    color: `${theme.color.mainBlue} !important`,
  },
  [`&& .MuiTabPanel-root`]: {
    marginTop: !isMobile && 24,
  },
}));

const Tab = ({ value, children }) => ({ children });

const Tabs = ({ value, tabChange, children, width, style }) => {
  const [tabValue, setTabValue] = useState(value);
  const arrayChildren = Children.toArray(children);
  const isMobile = useMobile();

  const onTabChange = (event, newValue) => {
    tabChange(newValue);
    setTabValue(newValue);
  };

  useEffect(() => {
    setTabValue(value);
  }, [value]);

  return (
    <TabContext value={tabValue}>
      <div
        style={{
          ...style,
          boxShadow: "0px 4px 4px 0px #4A69A626",
          display: "flex",
          justifyContent: isMobile ? "center" : "start",
          fontFamily: "Heebo, sans-serif",
          paddingInlineStart: !isMobile && 50,
        }}>
        <StyleTabs onChange={onTabChange} isMobile={isMobile}>
          {Children.map(arrayChildren, (child, index) => {
            return (
              <MuiTab
                key={index}
                label={child.props.label}
                value={child.props.value}
                style={{
                  fontFamily: "Heebo, sans-serif",
                  width: isMobile ? width || "50vw" : "auto",
                }}
              />
            );
          })}
        </StyleTabs>
      </div>
      {Children.map(arrayChildren, (child, index) => {
        return (
          <TabPanel key={index} value={child.props.value}>
            {child.props.children}
          </TabPanel>
        );
      })}
    </TabContext>
  );
};

export default Tabs;
export { Tab };
